"use strict";import{ColorSlider as e}from"./src/ColorSlider.js";import{defineElement as r}from"@spectrum-web-components/base/src/define-element.js";r("sp-color-slider",e);
//# sourceMappingURL=sp-color-slider.js.map
